import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class OnLocationPaymentComponent extends Component {
  static readonly TYPE_ID: string = 'b1d866c7b6f44424abdadae3694b2390';

  private constructor(
    public readonly hasOnLocationPayment: boolean,
  ) {
    super();
  }

  static create(args: {
    hasOnLocationPayment: boolean,
  }): OnLocationPaymentComponent {
    return new OnLocationPaymentComponent(
        args.hasOnLocationPayment,
    );
  }

  get $typeId(): string {
    return OnLocationPaymentComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): OnLocationPaymentComponent {
    return new OnLocationPaymentComponent(
        MapUtils.getBoolean(map, 'hasOnLocationPayment'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      hasOnLocationPayment: this.hasOnLocationPayment,
    };
  }

  clone(): this {
    return new OnLocationPaymentComponent(
        this.hasOnLocationPayment,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.hasOnLocationPayment === this.hasOnLocationPayment;
  }
}

export class OnLocationPaymentComponentBuilder extends DataModelBuilder<OnLocationPaymentComponent> {
  build(context: SerializationContext, map: SerializedData): OnLocationPaymentComponent {
    return OnLocationPaymentComponent.fromMap(context, map);
  }
}
